import { gql } from '@apollo/client';
import React from 'react';
import { Constrain } from '@moda/om';
import {
  CarouselPumoModuleGridFragment,
  CarouselPumoModuleGridFragment_cells_Look as LookCell
} from '../../generated/types/CarouselPumoModuleGridFragment';
import { CarouselCell, CAROUSEL_CELL_FRAGMENT } from '../Grid';
import { Grid } from '../Grid';
import { LookCellsGrid } from '../LookCellsGrid';

export const CAROUSEL_PUMO_MODULE_GRID_FRAGMENT = gql`
  fragment CarouselPumoModuleGridFragment on CarouselPumoModule {
    cells {
      ...CarouselCellFragment
    }
  }
  ${CAROUSEL_CELL_FRAGMENT}
`;

interface Props {
  carouselPumoModuleGrid: CarouselPumoModuleGridFragment;
}

export const CarouselPumoModuleGrid: React.FC<Props> = ({ carouselPumoModuleGrid }) => {
  if (carouselPumoModuleGrid.cells.every(cell => cell.__typename === 'Look')) {
    return <LookCellsGrid looks={carouselPumoModuleGrid.cells as LookCell[]} />;
  }
  return (
    <Constrain>
      <Grid>
        {carouselPumoModuleGrid.cells.map((carouselCell, i) => (
          <CarouselCell key={i} carouselCell={carouselCell} />
        ))}
      </Grid>
    </Constrain>
  );
};
